import { Modal, Button } from "react-bootstrap";

const ConfirmDeleteModal = ({
  show,
  onHide,
  onConfirm,
  itemType,
  itemName,
}) => {
  const getItemTypeLabel = () => {
    switch (itemType) {
      case "room":
        return "room";
      case "booking":
        return "booking";
      case "user":
        return "admin user";
      default:
        return "item";
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the {getItemTypeLabel()} "{itemName}"?
        {itemType === "room" && (
          <p className="mt-2 text-danger">
            This will also delete all bookings associated with this room.
          </p>
        )}
        {itemType === "user" && (
          <p className="mt-2 text-danger">
            This will remove admin access for this user.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
